<i class="mdi" [class.mdi-checkbox-blank-outline]="!selected" [class.mdi-checkbox-marked-outline]="selected"></i>
